import firebase from "../../Config/fbConfig";

export const answerQuestion = (id, body, completion) => {
    firebase.firestore().collection("questions").doc(id).update({
        reply: {
            date: new Date(),
            body: body
        }
    }).then(() => {
        completion(true);
    }).catch(function (error) {
        completion(null);
    });
};

export const deleteQuestion = (id) => {
    firebase.firestore().collection("questions").doc(id).delete();
};

export const createFAQ = (faq, completion) => {
    firebase.firestore().collection("faqs").add(faq).then(() => {
        completion(true);
    }).catch(function (error) {
        completion(null);
    });
};

export const deleteFAQ = (id) => {
    firebase.firestore().collection("faqs").doc(id).delete();
};


export const uploadTemp = (pers, companies, categories, completion) => {
    firebase.firestore().collection("temp").doc("temp").set({
        pers: pers,
        companies: companies,
        categories: categories,
    }).then(() => {
        completion(true);
    });
};



// WEBPACK FOOTER //
// ./src/Store/Actions/admin.js